import type { SpotUsage, UsageStatus, UsageType } from '../../../api/my-parking-spots';
import { formatDateTimeBR } from '../../../utils/date-utils';

export function getActualStartAt(usage: SpotUsage): string {
  return usage.actualStartAt ?? usage.startAt;
}

export function getActualEndAt(usage: SpotUsage): string {
  return usage.actualEndAt ?? usage.endAt;
}

export function formatUsageDate(iso: string): string {
  return formatDateTimeBR(iso);
}

export function formatUsagePeriod(startAt: string, endAt: string): string {
  return `${formatUsageDate(startAt)} — ${formatUsageDate(endAt)}`;
}

export function formatRequesterLabel(
  usage: Pick<SpotUsage, 'userName' | 'userEmail' | 'userApartmentNumber'>,
): string {
  const name = usage.userName?.trim() || usage.userEmail || 'Usuário';
  const apartment = usage.userApartmentNumber?.trim();
  return apartment ? `${name} (Apto ${apartment})` : name;
}

export function getUsageStatusLabel(status: UsageStatus | string): string {
  switch (status) {
    case 'PENDING':
      return 'Pendente';
    case 'ACTIVE':
      return 'Ativo';
    case 'CANCELLED':
      return 'Cancelado';
    case 'FINISHED':
      return 'Finalizado';
    case 'REJECTED':
      return 'Rejeitado';
    default:
      return status;
  }
}

export function getUsageTypeLabel(type: UsageType | string): string {
  switch (type) {
    case 'BORROW':
      return 'Empréstimo';
    case 'RENT':
      return 'Aluguel';
    default:
      return type;
  }
}

/** Empréstimo = verde, Aluguel = azul. */
export function getUsageTypeChipColor(
  type: UsageType | string,
): 'success' | 'accent' | 'default' {
  switch (type) {
    case 'BORROW':
      return 'success';
    case 'RENT':
      return 'accent';
    default:
      return 'default';
  }
}

export function getUsageStatusChipColor(
  status: UsageStatus | string,
): 'warning' | 'success' | 'danger' | 'default' {
  switch (status) {
    case 'PENDING':
      return 'warning';
    case 'ACTIVE':
      return 'success';
    case 'CANCELLED':
    case 'REJECTED':
      return 'danger';
    default:
      return 'default';
  }
}
